import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MemberModal = ({ member, onClose, onSubmit }) => {
  const isEditing = !!member;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    role: 'technician',
    specializations: '',
    location: '',
    hourlyRate: '',
    isActive: true,
  });

  useEffect(() => {
    if (member) {
      setFormData({
        fullName: member?.fullName || '',
        email: member?.email || '',
        phone: member?.phone || '',
        role: member?.role || 'technician',
        specializations: member?.specializations?.join(', ') || '',
        location: member?.location || '',
        hourlyRate: member?.hourlyRate || '',
        isActive: member?.isActive !== false,
      });
    }
  }, [member]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      const submitData = {
        ...formData,
        specializations: formData.specializations
          ? formData.specializations.split(',').map(s => s.trim()).filter(Boolean)
          : [],
        hourlyRate: formData.hourlyRate ? parseFloat(formData.hourlyRate) : null,
      };
      await onSubmit(submitData);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-premium border border-border max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <h2 className="text-xl md:text-2xl font-bold text-foreground">
            {isEditing ? 'Modifier le Membre' : 'Nouveau Membre'}
          </h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <Icon name="X" className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4">
          <Input
            label="Nom complet *"
            value={formData.fullName}
            onChange={(e) => setFormData(prev => ({ ...prev, fullName: e.target.value }))}
            required
            placeholder="Jean Dupont"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Email *"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
              required
              placeholder="jean@orazek.com"
            />
            <Input
              label="Téléphone *"
              value={formData.phone}
              onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
              required
              placeholder="+243..."
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Rôle *</label>
              <select
                value={formData.role}
                onChange={(e) => setFormData(prev => ({ ...prev, role: e.target.value }))}
                className="w-full h-10 px-3 py-2 rounded-xl border border-slate-300 dark:border-white/10 bg-white dark:bg-slate-900/60 text-slate-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/30"
                required
              >
                <option value="technician">Technicien</option>
                <option value="driver">Chauffeur</option>
                <option value="manager">Manager</option>
              </select>
            </div>
            <Input
              label="Taux horaire ($)"
              type="number"
              step="0.01"
              value={formData.hourlyRate}
              onChange={(e) => setFormData(prev => ({ ...prev, hourlyRate: e.target.value }))}
              placeholder="25.00"
            />
          </div>

          <Input
            label="Localisation"
            value={formData.location}
            onChange={(e) => setFormData(prev => ({ ...prev, location: e.target.value }))}
            placeholder="Lubumbashi, Kinshasa..."
          />

          <Input
            label="Spécialisations (séparées par des virgules)"
            value={formData.specializations}
            onChange={(e) => setFormData(prev => ({ ...prev, specializations: e.target.value }))}
            placeholder="Climatisation, Électricité, Plomberie..."
          />

          {isEditing && (
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                id="isActive"
                checked={formData.isActive}
                onChange={(e) => setFormData(prev => ({ ...prev, isActive: e.target.checked }))}
                className="w-4 h-4 rounded border-slate-300"
              />
              <label htmlFor="isActive" className="text-sm font-medium text-foreground">
                Membre actif
              </label>
            </div>
          )}

          <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4 border-t border-border">
            <Button type="button" variant="outline" onClick={onClose} className="w-full sm:w-auto">
              Annuler
            </Button>
            <Button type="submit" iconName="Save" iconPosition="left" className="w-full sm:w-auto" loading={loading}>
              {isEditing ? 'Modifier' : 'Créer'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemberModal;
